<template>
  <Popup title="车辆轨迹" minHeight='100%' ref="popup">
    <div class="bmap" ref="bmap"></div>
  </Popup>
</template>

<script>
import { nextTick, ref } from 'vue'
export default {
  name: 'Trajectory',
  props: {
    pointList: Array
  },
  setup (props) {
    let map = null
    let lineLayer = null
    const popup = ref(null)
    const showPopup = async() => {
      popup.value.show = true

      await nextTick()
      loadMap()
      // if (!map) {
      //   loadMap()
      // }
    }
    const bmap = ref(null)

    const loadMap = () => {
      // 1.初始化
      map = new BMapGL.Map(bmap.value)
      const point = new BMapGL.Point(115.985371, 36.456703) // 创建点坐标
      map.centerAndZoom(point, 16) // 初始化地图，设置中心点坐标和地图级别
      map.addEventListener('click', (e) => {

      })
      // map.enableScrollWheelZoom(true)
      const zoomCtrl = new BMapGL.ZoomControl() // 添加缩放控件
      map.addControl(zoomCtrl)
      const linePoint = props.pointList.map(item => new BMapGL.Point(item.longitude, item.latitude))
      const pointArr = props.pointList.map(item => [item.longitude, item.latitude])
      const data = [
        {
          geometry: {
            type: 'LineString',
            coordinates: pointArr
          }
        }
      ]
      var viewPort = map.getViewport(linePoint)
      map.centerAndZoom(viewPort.center, viewPort.zoom)
      const mapvgl = require('mapvgl')
      const view = new mapvgl.View({
        map: map
      })
      lineLayer = new mapvgl.LineLayer({
        color: 'rgba(50, 50, 200, 1)',
        width: 4,
        animation: true,
        duration: 1, // 循环时间2s
        trailLength: 1, // 拖尾长度占间隔的0.4
        interval: 0.1 // 粒子长度占线整体长度的0.2
      })
      view.addLayer(lineLayer)
      lineLayer.setData(data)
    }
    return {
      showPopup,
      bmap,
      popup

    }
  }
}
</script>

<style lang="scss" scoped>
.bmap {
  height: calc(100vh - 50px)
}
</style>
